
import React from "react";
import { cn } from "@/lib/utils";

interface HeroBannerProps extends React.HTMLAttributes<HTMLDivElement> {
  title: string;
  description?: string;
  image?: string;
  backgroundColor?: string;
  textColor?: string;
}

const HeroBanner = React.forwardRef<HTMLDivElement, HeroBannerProps>(
  ({ className, title, description, image, backgroundColor = "bg-blue-700", textColor = "text-white", ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(
          "w-full py-8 md:py-12 lg:py-16",
          backgroundColor,
          textColor,
          className
        )}
        {...props}
      >
        <div className="container px-4 md:px-6 mx-auto">
          <div className="grid gap-4 md:gap-6 lg:gap-10 lg:grid-cols-2 items-center">
            <div className="flex flex-col justify-center space-y-4">
              <div className="space-y-2">
                <h1 className="text-2xl font-bold tracking-tighter sm:text-3xl md:text-4xl lg:text-5xl">
                  {title}
                </h1>
                {description && (
                  <p className="max-w-[600px] text-base md:text-lg lg:text-xl text-muted-foreground md:text-xl/relaxed lg:text-base/relaxed xl:text-xl/relaxed">
                    {description}
                  </p>
                )}
              </div>
            </div>
            {image && (
              <div className="flex items-center justify-center mt-4 md:mt-0">
                <img
                  src={image}
                  alt="Hero"
                  className="mx-auto aspect-video overflow-hidden rounded-xl object-cover object-center w-full max-w-[550px]"
                  width={550}
                  height={310}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
);

HeroBanner.displayName = "HeroBanner";

export { HeroBanner };
